__turbopack_context__.v({
  "backwards": "button-module__6KZRRG__backwards",
  "blueButton": "button-module__6KZRRG__blueButton",
  "btn": "button-module__6KZRRG__btn",
  "orangeButton": "button-module__6KZRRG__orangeButton",
  "purpleButton": "button-module__6KZRRG__purpleButton",
  "svg": "button-module__6KZRRG__svg",
  "whiteButton": "button-module__6KZRRG__whiteButton",
});
